export default {
    data() {
        return {
            maxH: '',
            maxW: '',
            cutH: 270,
            cutW: 230,
            staticH:200,
            columnH:''
        }
    },
    mounted() {
        this.windowResize();
        window.addEventListener("resize", this.windowResize, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.windowResize, false)
    },
    methods: {
        windowResize() {
            this.maxH = (document.body.clientHeight || window.innerHeight) - this.cutH;
            this.columnH = (document.body.clientHeight || window.innerHeight) - this.staticH;
            this.maxW =(document.body.clientWidth || window.innerWidth) - this.cutW;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/windowResize.js